import React from 'react'
import Manager from '../../public/components/Manager'
import VacationDeductionInfoDiv from './VacationDeductionInfoDiv'
Ext.require('Ext.Toast')

const config = {
    tabs: {
        有效假勤: {
            export: true,
            exportColumns: [
                { _text: '员工编号', field: 'Person.PersonNo', minWidth: 150, search: true, },
                { _text: '中文姓名', field: 'Person.ActualName', minWidth: 150, search: true, },
                // { _text: '英文姓名', field: 'Person.PersonNameE', minWidth: 150, search: true, },
                { _text: '假勤项目', field: 'Name', minWidth: 150, search: true, filter: ['select'], },
                { _number: '总时长', field: '_TotalTime', minWidth: 150, },
                { _number: '已休时长', field: '_UseTime', minWidth: 150, },
                { _number: '剩余时长', field: '_RemainingTime', minWidth: 150, },
                { _datetime: '给假起始日', field: 'StartDate', minWidth: 150, filter: true, align: 'left' },
                { _datetime: '可休截止日', field: 'EndDate', minWidth: 150, filter: true, align: 'left' },
                // { _text: '部门代码', field: 'Person.Dep.F0', minWidth: 150, search: true, },
                { _text: '部门名称', field: 'Person.Dep.ShortName', minWidth: 150, search: true, },
                // { _text: '职务名称', field: 'Person.PersonDuty', minWidth: 150, search: true, },
                // { _text: '责任区分', field: 'Person.ResponsibilityDistinguish', minWidth: 150, search: true, },
                // { _text: '员工类别', field: 'Person.EmployeeCategory', minWidth: 150, search: true, },
                { _date: '到职日期', field: 'Person.AppointmentDate', minWidth: 150, filter: true, align: 'left' },
                { _text: '分机号码', field: 'Person.PersonOfficeTel', minWidth: 150, search: true, },
                { _text: '邮箱', field: 'Person.PersonEmail', minWidth: 150, search: true, },
            ],
            buttons: [
            ],
            columns: [
                { _text: '员工编号', field: 'Person.PersonNo', minWidth: 150, search: true, },
                { _text: '中文姓名', field: 'Person.ActualName', minWidth: 150, search: true, },
                // { _text: '英文姓名', field: 'Person.PersonNameE', minWidth: 150, search: true, },
                { _text: '假勤项目', field: 'Name', minWidth: 150, search: true, filter: ['select'], },
                { _number: '总时长', field: '_TotalTime', minWidth: 150, },
                { _number: '已休时长', field: '_UseTime', minWidth: 150, },
                { _number: '剩余时长', field: '_RemainingTime', minWidth: 150, },
                { _datetime: '给假起始日', field: 'StartDate', minWidth: 150, filter: true, align: 'left' },
                { _datetime: '可休截止日', field: 'EndDate', minWidth: 150, filter: true, align: 'left' },
                // { _text: '部门代码', field: 'Person.Dep.F0', minWidth: 150, search: true, },
                { _text: '部门名称', field: 'Person.Dep.ShortName', minWidth: 150, search: true, },
                // { _text: '职务名称', field: 'Person.PersonDuty', minWidth: 150, search: true, },
                // { _text: '责任区分', field: 'Person.ResponsibilityDistinguish', minWidth: 150, search: true, },
                // { _text: '员工类别', field: 'Person.EmployeeCategory', minWidth: 150, search: true, },
                { _date: '到职日期', field: 'Person.AppointmentDate', minWidth: 150, filter: true, align: 'left' },
                { _text: '分机号码', field: 'Person.PersonOfficeTel', minWidth: 150, search: true, },
                { _text: '邮箱', field: 'Person.PersonEmail', minWidth: 150, search: true, },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => {
                Tyan.pubForm.showDialog('请假明细', VacationDeductionInfoDiv, { id: data.id, onFlowFinished: refreshPage }, { height: 500, minWidth: 900 })
                //Tyan.pubForm.showDialog('请假明细', props => <VacationDeductionInfoDiv {...props} id={data.id} onFlowFinished={refreshPage} />)
            }
        },
        失效假勤: {
            export: true,
            exportColumns: [
                { _text: '员工编号', field: 'Person.PersonNo', minWidth: 150, search: true, },
                { _text: '中文姓名', field: 'Person.ActualName', minWidth: 150, search: true, },
                // { _text: '英文姓名', field: 'Person.PersonNameE', minWidth: 150, search: true, },
                { _text: '假勤项目', field: 'Name', minWidth: 150, search: true, filter: ['select'], },
                { _number: '总时长', field: '_TotalTime', minWidth: 150, },
                { _number: '已休时长', field: '_UseTime', minWidth: 150, },
                { _number: '剩余时长', field: '_RemainingTime', minWidth: 150, },
                { _datetime: '给假起始日', field: 'StartDate', minWidth: 150, filter: true, align: 'left' },
                { _datetime: '可休截止日', field: 'EndDate', minWidth: 150, filter: true, align: 'left' },
                // { _text: '部门代码', field: 'Person.Dep.F0', minWidth: 150, search: true, },
                { _text: '部门名称', field: 'Person.Dep.ShortName', minWidth: 150, search: true, },
                // { _text: '职务名称', field: 'Person.PersonDuty', minWidth: 150, search: true, },
                // { _text: '责任区分', field: 'Person.ResponsibilityDistinguish', minWidth: 150, search: true, },
                // { _text: '员工类别', field: 'Person.EmployeeCategory', minWidth: 150, search: true, },
                { _date: '到职日期', field: 'Person.AppointmentDate', minWidth: 150, filter: true, align: 'left' },
                { _text: '分机号码', field: 'Person.PersonOfficeTel', minWidth: 150, search: true, },
                { _text: '邮箱', field: 'Person.PersonEmail', minWidth: 150, search: true, },
            ],
            buttons: [
            ],
            columns: [
                { _text: '员工编号', field: 'Person.PersonNo', minWidth: 150, search: true, },
                { _text: '中文姓名', field: 'Person.ActualName', minWidth: 150, search: true, },
                // { _text: '英文姓名', field: 'Person.PersonNameE', minWidth: 150, search: true, },
                { _text: '假勤项目', field: 'Name', minWidth: 150, search: true, filter: ['select'], },
                { _number: '总时长', field: '_TotalTime', minWidth: 150, },
                { _number: '已休时长', field: '_UseTime', minWidth: 150, },
                { _number: '剩余时长', field: '_RemainingTime', minWidth: 150, },
                { _datetime: '给假起始日', field: 'StartDate', minWidth: 150, filter: true, align: 'left' },
                { _datetime: '可休截止日', field: 'EndDate', minWidth: 150, filter: true, align: 'left' },
                // { _text: '部门代码', field: 'Person.Dep.F0', minWidth: 150, search: true, },
                { _text: '部门名称', field: 'Person.Dep.ShortName', minWidth: 150, search: true, },
                // { _text: '职务名称', field: 'Person.PersonDuty', minWidth: 150, search: true, },
                // { _text: '责任区分', field: 'Person.ResponsibilityDistinguish', minWidth: 150, search: true, },
                // { _text: '员工类别', field: 'Person.EmployeeCategory', minWidth: 150, search: true, },
                { _date: '到职日期', field: 'Person.AppointmentDate', minWidth: 150, filter: true, align: 'left' },
                { _text: '分机号码', field: 'Person.PersonOfficeTel', minWidth: 150, search: true, },
                { _text: '邮箱', field: 'Person.PersonEmail', minWidth: 150, search: true, },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => {
                Tyan.pubForm.showDialog('请假明细', VacationDeductionInfoDiv, { id: data.id, onFlowFinished: refreshPage }, { height: 500, minWidth: 900 })
                //Tyan.pubForm.showDialog('请假明细', props => <VacationDeductionInfoDiv {...props} id={data.id} onFlowFinished={refreshPage} />)
            }
        },
    }
}

export default props => <Manager {...props} config={config} />